import { createAction, props } from '@ngrx/store';

import { EndorsementCreate } from '@lockton-apps/shared/interfaces';

export enum QuoteEndorsementsActionsTypes {
  Init = '[Quote Endorsements Page] Initialised',
  FormSubmitted = '[Quote Endorsements Page] Form Submitted',
}

export const QuoteEndorsementsActions = {
  init: createAction(QuoteEndorsementsActionsTypes.Init),
  formSubmitted: createAction(
    QuoteEndorsementsActionsTypes.FormSubmitted,
    props<{ endorsement: EndorsementCreate }>()
  ),
};
